<template>
  <div :class="fadeClasses" class="knight-to-man">
    <Left class="ktm-left" />
    <Man class="man" />
    <Right class="ktm-right" />
  </div>
</template>

<script>
import { Power1, Bounce, TimelineMax } from 'gsap'
import { mediaQueryMixin, fadeMixin } from '@/mixins'
import Left from './Left'
import Man from './Man'
import Right from './Right'

export default {
  name: 'KnightToMan',
  components: {
    Left,
    Man,
    Right
  },
  mixins: [mediaQueryMixin, fadeMixin],
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerElement: '.knight-to-man'
    })

    const timeline = new TimelineMax()
      .to('.ktm-left', 1, {
        x: '-45px',
        ease: Power1.easeOut
      }, 0)
      .to('.ktm-left', 1.2, {
        rotation: -90,
        ease: Bounce.easeOut
      }, 0.2)
      .to('.ktm-left', 0.8, {
        opacity: 0
      }, 0.8)
      .to('.ktm-right', 1, {
        x: '45px',
        ease: Power1.easeOut
      }, 0)
      .to('.ktm-right', 1.2, {
        rotation: 90,
        ease: Bounce.easeOut
      }, 0.2)
      .to('.ktm-right', 0.8, {
        opacity: 0
      }, 0.8)
      .fromTo('.man', 1, {
        opacity: 0
      }, {
        opacity: 1
      }, 0.3)

    this.$scrollmagic.addScene(
      scene.setTween(timeline)
    )
  }
}
</script>

<style lang="scss" scoped>
.knight-to-man {
  height: 246px;
  margin: 100px auto;
  text-align: center;
  position: relative;
  z-index: 2;

  * {
    position: absolute;
  }
}

.grab-left,
.grab-right {
  width: 168px;
  height: auto;
}

.ktm-left,
.ktm-right {
  width: 30px;
  height: auto;
  z-index: 2;
}

.ktm-left {
  right: 50%;
  transform-origin: 100% 100%,
}

.ktm-right {
  left: 50%;
  transform-origin: 0% 100%;
}

.man {
  width: 58.5px;
  height: auto;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: 1;
}
</style>
